import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import DigitalIDCard from '../../../components/DigitalIDCard/DigitalIDCard';
import styles from '../Settings.module.css';

const MyIdTab: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className={styles.tabContent}>
      <div className={styles.sectionHeader}>
        <h3>Your Digital Dietary ID</h3>
        <p className={styles.sectionDescription}>
          Your personalized dietary identity card that you can use at restaurants, 
          grocery stores, and meal services. Share this with venues to get 
          personalized recommendations based on your preferences.
        </p>
      </div>
      
      <div className={styles.idCardContainer}>
        <DigitalIDCard />
        <div className={styles.idCardInfo}>
          <h4>How to Use Your ID</h4>
          <p>Show this card at participating restaurants or scan QR codes at venues to automatically share your dietary preferences and get personalized menu recommendations.</p>
          
          <h4>Privacy & Security</h4>
          <p>Your data is encrypted and you control what information is shared. You can update your preferences anytime and they'll be reflected immediately on your ID card.</p>
        </div>
      </div>
    </div>
  );
};

export default MyIdTab;
